<template>
  <div
    :class="[
      'group relative py-2 transition-colors',
      diffClass,
      editMode ? 'rounded border border-transparent pr-10 hover:border-primary hover:bg-blue-50 focus-within:border-primary focus-within:bg-blue-50' : '',
    ]"
    :style="{ paddingLeft: indent }"
  >
    <IconButton
      v-if="editMode"
      icon="pen"
      tooltip="Edit paragraph"
      aria-label="Edit paragraph"
      class="!absolute !right-1 !top-1 !m-0 opacity-70 group-hover:opacity-100 group-focus-within:opacity-100"
      @click="$emit('edit', paragraph)"
    />
    <div class="flex items-baseline gap-2">
      <span v-if="paragraph.label" class="w-9 flex-none text-sm font-bold text-primary">{{ paragraph.label }}</span>
      <div class="min-w-0 flex-1">
        <strong v-if="paragraph.heading" class="mb-1 block text-sm text-gray-800">{{ paragraph.heading }}</strong>
        <MarkdownMath :content="paragraph.text" />
        <div v-if="paragraph.crossReferences?.length" class="mt-2 flex flex-wrap gap-1">
          <CrossRefChip v-for="(xref, index) in paragraph.crossReferences" :key="index" :xref="xref" />
        </div>
        <AssetCard v-for="asset in assets" :key="asset.assetId" :asset="asset" />
      </div>
    </div>
    <p v-if="diffStatus && diffStatus !== 'unchanged'" :class="['mt-1 text-xs font-bold uppercase', diffLabelClass]">
      {{ diffStatus }}
    </p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { IconButton, MarkdownMath } from "@comp";

import AssetCard from "./AssetCard.vue";
import CrossRefChip from "./CrossRefChip.vue";

const props = defineProps({
  paragraph: { type: Object, required: true },
  assets: { type: Array, default: () => [] },
  diffStatus: { type: String, default: undefined },
  editMode: { type: Boolean, default: false },
});
defineEmits(["edit"]);
const indent = computed(() => `${(props.paragraph.level || 0) * 20 + 4}px`);
const diffClass = computed(() => ({
  changed: "border-l-4 border-yellow-400 bg-yellow-50 pl-2",
  added: "border-l-4 border-green-400 bg-green-50 pl-2",
  removed: "border-l-4 border-red-400 bg-red-50 pl-2 opacity-60",
}[props.diffStatus] || ""));
const diffLabelClass = computed(() => ({
  changed: "text-yellow-700",
  added: "text-green-700",
  removed: "text-red-600",
}[props.diffStatus] || ""));
</script>
